import React, {useEffect, useState} from 'react'
import OwlCarousel from 'react-owl-carousel'
import $ from 'jquery'
// Components
import ProductCard from '../components/ProductCard'
import PageTransition from '../components/PageTransition'
// CSS
import '../assets/css/product.css'
import '../assets/css/form.css'
import '../assets/owl carousel/owl.carousel.min.css'
import '../assets/owl carousel/owl.theme.default.min.css'

export default function Product(props) {
  const [cartAddCount, setCartAddCount] = useState(1);
  const [activeTab, setActiveTab] = useState('description');

  useEffect(() => {
    $('.cart_add_count').val(1);
  }, [])

  function handleShowImage(key){
    document.querySelectorAll('.product_images .images .card').forEach(card => {
      card.classList.remove('active');
    });

    document.querySelector(`.product_images .images .card_${key}`).classList.add('active');

    document.querySelector('.product_images .image_show img').src = document.querySelector(`.product_images .images .card_${key} img`).src;
  }

  const [ratingSelected, setRatingSelected] = useState(0);
  document.querySelectorAll('.rating_selector span').forEach((ratingOption) => {ratingOption.classList.remove('active')})
  for(var i = 1; i < ratingSelected+1; i++) {
    
    document.querySelector('.rating_option_'+i).classList.add('active');
  }

  useEffect(() => {
    activeTab === 'description'?
    $('.section.description').addClass('active')
    :
    $('.section.reviews').addClass('active')
  }, [activeTab])

  function decreaseCartCount(){
    if(cartAddCount > 1){
      document.querySelector('.cart_add_count').value = cartAddCount - 1;
    }
  }

  return (
    <div className='product_page'>
      <PageTransition />
      <div className='container'>
        <div className='header'>
          <div className='product_images'>
            <div className='image_show'>
              <img src={require('../assets/images/product.png')} alt='product' />
            </div>
            <div className='images'>
              <div className='card card_1 active' value='1' onClick={() => {handleShowImage(1)}}>
                <img src={require('../assets/images/product.png')} alt='product' />
              </div>
              <div className='card card_2' value='2' onClick={() => {handleShowImage(2)}}>
                <img src='data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBxANDQ0NDQ8PDQ0NDQ0NDQ0NDQ8NDQ0NFREWFhURFRUYHSggGBolGxUVITEhJSkrLi4vFys1RDM4NygtLi0BCgoKDg0NFQ8PFSsdFR0rKysrKysrLSsrLS03KysrNy0rLS0rKysrKy0wKysrKystKys3KystKystLSstKysrK//AABEIALcBEwMBEQACEQEDEQH/xAAbAAADAQEBAQEAAAAAAAAAAAAAAgMBBAUGB//EAD4QAAMAAQMABgcFBQYHAAAAAAABAgMEERIFEyExQVFSYXGBkZLwBoKhwdEiQrHS4RQjQ2KTogdEU2NkcvH/xAAZAQEBAQEBAQAAAAAAAAAAAAAAAQIDBAX/xAAwEQEAAgICAQEGBAYDAQAAAAAAARECEgNREwQhMUFSYZEFFKGxIiOBwdHwQlNxMv/aAAwDAQACEQMRAD8A/Ldj2q3YqtKN2KN2A1IqmSFDUi0G4lG7AbxKN4gbxCt4loZwJQZSWhvEA4gHEDOIBxAziBnEgxyEY5JRTNgUVogxoDNiBdiDNgMaCM2IM2IjCBkjSt2KNSAZIqtSAZIo3YoZIqtUgMpKGUgapAZSUbwC03iChxBTeIKHEA4AHADOAKZwIUziArkDHIQrkgVyBmxArREY0ArRArRBmwGbERmwDJBWpFDJFDKShkgNSKplJQykBlJVOpAZSAykqmUAaoA3gFbwA3gAcADgBnADOBBjgDHBUK4IFcgorkJRXJAjkBXIQrkgxogVoiFaIFaAzYiGSKpkih0iqZIo1SVTqQHUgoykq0ZSFOoAdQA6gKZQAyxgMoA1YxYOrC03qwUOrBTHjIUx4ylFeMJRXjBRXACuAEcBKI4AVyRKI5ARyRCuQFaJQRoiFaIjNgHSCmSKplJQ6kqnUgOpKtHUBaOoBR1AKUmAtHWMFHWMLR1jBRljBR1jItNWMFN6sFN6sFM6sFDqhZRXjBTHjFlEeMWUR4wlEeMpRHAKTcBKI4CURwQojkJRHIKI5CJuSIVohRdiJR0iqdSVTqRa0opC0dSUpSYC0pMCylJgWtKTjFrSk4yWKTjFrR1jJZR1jFrR1jFlGWIlhliFjeqFjeqJYOqFjHiFhXjLYV4xZRHjFlEeMWUR4y2lJ1jFlJ1jFlJ1BbSk6gWlJ1AtKTqCWUm5CURyEojkITiRFJkNUopFrR5kWtKTBbWlJgWtKzAtaVnGSylJgWtKzBLKUnGLWlJxiylJxEsVnCTYUnETYo6wk2KMsJNlo3UjYpvUjYodSNiivCNiivEXZKJWIbFJ1iLsqdYi2J1jLZSVYxZSdQW0pKoBSdQLSkqgpSVQEpOpDNJ1JEpNyEonEJSsyGqPMhqlZkLSkwLWlZxi1WmCWKzAtVZxksVnGS1VjGTYWnETZFZxGdlVnCScilFiM7LR1iJuUdYibqbqibg6obg6obhXiLuUV4hulEeMu5SdYi7lJVjLulJXiNRmUlWIuwjWMuxSVYy7FJVjLslJVA2KSuC7JSNQXZKSqRaJVJLQmxbRSZMWtKzItqIWiRs1qtEE2WlpgmxSswTZaVmCbFLRjM7rS0YyeQpaMZmeRdVpgzuaqzJnddTzJmc11UUk3XU6kz5DQ6kz5F0NxJ5GvGOBPIeMOS+Q8ZXI8ieMjk15E0TaLuaEaLumidSXc1TqS7mqNSa3TRG5NRmaI3JqMzVGpLumqNyXdNUqRdzVG5NbpqjUl3TVGpGzE4k2Gyamk57OlLSTZqIVlk3a1WlknNdVZZnddVoZmc11Whk3XRaGYnka0Wlmd10VmjM5rooqMzyGik0Z8jXjUmjM8i+NSWZnkajjUkxPK1HGrKMTyteI+3Y3tv2dy23fqMTzfVfG8jWfaDFiwLOlyj+8nInSm8GdQ6nDkn92m1x7e5teZ3w48sstf9mO4efPlxxx2/2J6ln2Y6cnX4ObUxmhtZcUt1w3p8X2rxS3HqMZ4sq+EnpeSObG/jHverRxjlejxpUbjlZ8aVM3HInjSpl8ieNOqNeRPGnVmozTxpVZqM00RuzUZmiN0ajNNEbs1GbOiF2b2Z0Rqy7JqlVGtk1Sqi7M6o3ZdmZxTdl2Z1TnKZbilZykaiFJzEbpWcyMtRCs5zPtaiFZzmZtqMVZ1BibajFadSZmG9VJ1K8zM2uqs6hGJtdFY1CMzbWi06hGZtdFYzrzOc21GC85UYm2tF4s5zbUYLxRyymW4wWmjlOUlPnftp0Ppr02fVZMKeojE1jyxym+b/ZjfZrkk2u/fsPb6H1HL5MeOMv4b9rw+r9Px54ZZzj/ABRDwP8Ahvq4x5c+BpvLmStNTupx4127vw7bPb+J45TjjlE+yP7vH+FzGOeWEx/FP9n3V0fKxmX2pxc+TIdYtmcHPeZHSIlnRz3qEdIiWdEb1SNxCaI1ql5m4xlNUb1a8zUYyzOKF6xeZuMZZqEa1a8zcYyk0lWrXmajGWJpKtUjUYyzNJVqkbjGWJmEa1KNayxOUJ1qTUYyxOUJVqC6sTnBOvLqztDyuVelXzM1UvnbZdjnfpV8zGptl3Led+lXzMayu+fc/ccsnpV8zGs9G+fc/dqrI/3rf32NTbOfjP3Ooyvud/O/1Gn0X+Z3P3N1Wf8A7nzv9Rov8zufuW4yrvdr7zGiT5I98yJnL4VX+p/Uvj+hefc/c6w5343/AKn9R4/ov8zufuZYNR4PJ7sj/Unjjpa5e5+51g1Xg83uuv1Hjj6LXN3P3b1Gr/8AI+bJ+pNMfotc3c/eSVotQ++Mz9s2xrjHSacs9q49Pqp24rUz5cVm/Ik48c++m8ceaPm/V9P0d9odZEqcumyZmv3+qyY6ft2lp+5I8PJ6Hiym8c6fY4fXcsRWeF/WqezpftDkrbfSZl9zJ/KePk9BjHuzh7sOfHP4TDoyavT48WVZ9PlyZNTk/uctLJWTHb3fV7bftLv2S7kvUc8ePO6ivZX+/wBXTKdJxyjOsfjFe98z9n+kq0+LLeLBeRZ81VLU5HKlJLZOZfime/m9PHLMbZVUPn8PNjhGeeOP/wBTK+f7T6nw0tfLm/lLj+H8Xz/smX4lnHu4/wB/8OPJ9otS/wDl2vbGb9DrHouKP+TlP4py/wDX+7lydOan/pP5Mn6G49JxR8XOfxPm/wCv93PXTGpf+G/ks3+X42J/Eub5P3SrpXP4zt92yxwYMT+Ic3y/pKddJ5vL/bZrw4MT6/m6/cj6Ry+S+Wi+PFmfXcvRH0hk9XwZfHiz+c5SvXZPV8GXTFn83yletvzXwY1hPzXIV6y/NfAawz+Z5O2PVV5otJ58+y/2ivNBnzZ9jr68wnlyZ1r8wnkyZ1j80DfI6wrzLoaw1YF6Q1XSOzLTLzY1XSOzLTr0qLqukdmWnnzoUukdnnTT51+IpqMIXjSrzr4tEtuOOO5VnS+VWvvEtuOP6yvGm/z38xicvo6Y8cdyvOn/AMz9+zOc5z06Rxx2edMvFp+2ZMznPTcceKk6KH3qH92TM8ucNxwccrR0fj8p93Z/BmJ9RyNR6biVno6P/l2vzJ+Z5Omvy3H26cfReN+Nr2Zcv8xzn1efTcelw7l2Y+iZ8MuVezJb/izlPrMvjjH6f4bj00fDKVsmh6rHeR59Q1EumoqHWy79t0c49TOeURpDc8fjxnLaZo+LRZMmOLWozLdK562MDyY213b8Ox7dnYznl6nHHKYnCP6e5ceOc8Yy2+8RbxOiOjc+OtTpI1DiNLlXBNJp48i5p93m6+B68vU8euOc4Xs8nDw8kZZ8cZ1rP6T7XVl6P1S7tTD9uFv80MfVcPyOk8HN88fZyZNJrF/jY39xr8ztHqOD5XKeH1HzQ5rw6xeOKvbTX5HSObg6c54vU9wk1q13xjfsyfqjccnAzp6nqPulV6ld+KX7Mkmoz4e2Jx9R8v6ovNqF34X7qh/ma24u2J8/yfsR6rKu/DfuSf8AAt8fbM5cvySnWsvxxX8lFjTtmc+T5JTeufjFL2xRqse2fLl8skrXLxlr3MtR2z5e4Teun2FqO080dMern6Za+qeWCvUSKTyQV5kKhN4K8qCbQXmvpIJtAWP1sJX1Msa82F1jtqxz5sLrHZ1ij0n8yHtXXHsyiPSfzoXK649mU4/S/wBwuVrDsyjH5t++h7VrBXHwXhX+4TbUauibj0X+P6mNZ7bjLHpeMk+j9fExOM9ukZR0vFryMzjPbcZR0rOReS+JicG4zVWoS73K+8Ynib8q+PUp9zXx/oYnhluOWHRGo+tzlPC3HI6I1exzngt0jlJ0jrN8FruVuMbbfHabtS2n4PZ9hMOCIyiemeXlmcJjv2PU0eZdRaSX928ezT7FLXctvh8Dz8nF/H/67YZ+yunl45mNVn1DqneacUJcL4xELu38d22zvOEzxxh8Iccajly5PjNQvepMxwuk8jnyZzpHEzPI5rzr6R0jilieVK8pqONmeRG8huONmeVKrNaMTyJ1ZrRndOrLom6VUXVndOrNapulTRdZZnKEqS8l8C1LEzHSdY59GfgjVMTGPSdYp9Gfgi0zOOPSbwz5IMTjj0Xqp8v4lpNcekVHrNuNNUfWxVoyhfSQWoMpX1sUoyn63C0dL1L4sK1S/V8ChlL818EFPM/5n+AWP/Tqn6V+4lLf1Vm//Z+1/wBRq1GR5t+S95KajJRZPNR8EyatbLY823c5XsSMzi1GS85/N/gZnB0jNadTt4mJ4objkJ0hqd8GRb/u7rz5LtT+KRI4oibTPkmcJep0drb/ALHbSW1cHb3Sa7O7bvPNycOPli3p4+TKeO3jabW09Rqf2m4XVJLwVce3Y9Hiinlx5spzy9vsdNar1/gWOJqeRN6g142ZzJWdl0hmciPMXRN03m9Y1Z2Teb1jRNiVlLqmydZS6puR5C6puR5Rqm5HkGqbkeQtM7kdik2K7FJsV0KSy8hSWlyKw3mLLbzFrbVZbLbzFlmVlW28wWZWVbMrBZlf1uFsysUtmWQtFtlpeC+CRKW1FkFLsdZvWKa2Os/rJSxkbr15kprZWNQurp7W2l2cV+z72cs8qyiPY7Y1pM+15/Ruo7Lrxu3T9pvGLh5uPL3ut6k1q3uR6kurO5XqGNU3I8wpNiPKKZ2K8paTYryELK8gSyuwWV2EsrshbHQSy8gWzkRLZuBm4RMyjSgA3co3cK1UUtvItlt5C1byLZbVQstvMLbeZbLarC2brAWOsBbes+twttWR+ZF2WrW55xOJvjD7OKmU9vU1O/4nmz48Zy2r2vRHLyxx1jl7HDpsr3e/b6zrxvLGUujrDqts6wFs6wJbHYLZzCWzkQtnIDORLS2cgM5ELZyCWzkC2bkLZuAbgZuRCGUaAbltWiwblsbuLBuLG7lsG4G7i1G5bG8hY3kLByLat5CyxyFjVQtbUWfaK2/hP5nLOLl2jkrCYhzYn3msHntXkbtWchZY5Cy2ciWls5CyxyFls3JYzcWDcIzcWDcljNxYNxYNyWM3Fg3IjCKAAAACo3cKAAWDctjdxYNy2DcWN3ANxYNy2N3Fq3kLGu+zu/AzLe3s9xExDFt3NWM3FoNyWDcWM3ANxYNxYzclg3Fg3JYNwM3AAgIAKNwMIAAAAADSgAAAAKADQAWAAANyjdxYzchYKAA3FgACWAAAwAIAAAAAAIMABYAMIgAArQAAACgAAADQAoAAAAAAAAAAAAAAWAAIMAAAAAAAgAAIwAACAKAAAAAAAAADQAAACqAAIAoA3cKNwgAwAAAAgAAAAAjAAAAAAAAAMIAAAAAAA0AAAAoAAAAAAAANwN3AAo3AAADAgAAAAIAAAAMAAAAAAP/Z' alt='product' />
              </div>
              <div className='card card_3' value='3' onClick={() => {handleShowImage(3)}}>
                <img src={require('../assets/images/product-hover.png')} alt='product' />
              </div>
              <div className='card card_4' value='4' onClick={() => {handleShowImage(4)}}>
                <img src='https://images.unsplash.com/photo-1518791841217-8f162f1e1131?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60' alt='product' />
              </div>
            </div>
          </div>
          
          <div className='details'>
            <div className='name'>BLack Headset with brand new technology.</div>
            <div className='ratings'>
              <span className='fas fa-star active'></span>
              <span className='fas fa-star active'></span>
              <span className='fas fa-star active'></span>
              <span className='fas fa-star active'></span>
              <span className='fas fa-star'></span>
            </div>
            <div className='price'><span className='discount_price'>{props.currency}200</span> <span className='real_price'>{props.currency}500</span></div>
            <div className='color selector'>
              <div className='title'>Color: </div>
              <div className='options'>
                <div className='card' style={{background: 'red'}}></div>
                <div className='card' style={{background: 'green'}}></div>
                <div className='card' style={{background: 'blue'}}></div>
                <div className='card' style={{background: 'black'}}></div>
              </div>
            </div>
            <div className='size selector'>
              <div className='title'>Size: </div>
              <div className='options'>
                <div className='card'>S</div>
                <div className='card'>M</div>
                <div className='card'>L</div>
                <div className='card'>XL</div>
              </div>
            </div>

            <div className='cart'>
              <div className='quantity'>
                <button className='fas fa-minus' onClick={() => {decreaseCartCount(); setCartAddCount(cartAddCount-1)}}></button>
                <input className='cart_add_count' type='number' min={1} onChange={() => {setCartAddCount($('.cart_add_count').val())}} />
                <button className='fas fa-plus' onClick={() => {document.querySelector('.cart_add_count').value = parseInt(document.querySelector('.cart_add_count').value)+1; setCartAddCount(cartAddCount+1); console.log('added')}}></button>
              </div>

              <button className='primary_btn cart_btn'>Add to cart</button>
            </div>

            <div className='bottom_links'>
              <div className='share'>
                <a href='' className='fab fa-facebook'></a>
                <a href='' className='fab fa-twitter'></a>
                <a href='/mailto'className='fas fa-envelope'></a>
              </div>

              <button className='wishlist'><span className='far fa-heart'></span> Add to wishlist</button>
            </div>
          </div>
        </div>
        
        <div className='section_tabs'>
          <button className={activeTab === 'description'? 'active' : ''} onClick={() => {setActiveTab('description')}}>Description</button>
          <button className={activeTab === 'reviews'? 'active' : ''} onClick={() => {setActiveTab('reviews')}}>Reviews</button>
        </div>
        
        {
          activeTab === 'description' ?
          <div className='section description'>
            <div className='section_title'>Description</div>
  
            <div className='content'>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, nostrud ipsum consectetur sed do, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat.
                <ul>
                  <li>Lorem ipsum dolor sit amet</li>
                  <li>Lorem ipsum dolor sit amet</li>
                  <li>Lorem ipsum dolor sit amet</li>
                  <li>Lorem ipsum dolor sit amet</li>
                  <li>Lorem ipsum dolor sit amet</li>
                </ul>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, nostrud ipsum consectetur sed do, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat.
              </p>
            </div>
          </div>
          : <></>
        }

        {
          activeTab === 'reviews' ?
          <div className='section reviews'>
            <div className='section_title'>Reviews</div>
            <div className='content'>
              <div className='reviews'>
                <div className='card'>
                  <div className='top'>
                    <div className='username'>forhadhossain60</div>
                    <div className='ratings'>
                      <span className='fas fa-star active'></span>
                      <span className='fas fa-star active'></span>
                      <span className='fas fa-star active'></span>
                      <span className='fas fa-star active'></span>
                      <span className='fas fa-star'></span>
                    </div>
                  </div>
                  <div className='review_text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, nostrud ipsum consectetur sed do, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit</div>
                </div>
                
                <div className='card'>
                  <div className='top'>
                    <div className='username'>forhadhossain60</div>
                    <div className='ratings'>
                      <span className='fas fa-star active'></span>
                      <span className='fas fa-star active'></span>
                      <span className='fas fa-star active'></span>
                      <span className='fas fa-star active'></span>
                      <span className='fas fa-star'></span>
                    </div>
                  </div>
                  <div className='review_text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, nostrud ipsum consectetur sed do, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit</div>
                </div>
                
                <div className='card'>
                  <div className='top'>
                    <div className='username'>forhadhossain60</div>
                    <div className='ratings'>
                      <span className='fas fa-star active'></span>
                      <span className='fas fa-star active'></span>
                      <span className='fas fa-star active'></span>
                      <span className='fas fa-star active'></span>
                      <span className='fas fa-star'></span>
                    </div>
                  </div>
                  <div className='review_text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, nostrud ipsum consectetur sed do, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit</div>
                </div>
              </div>
  
              <form className='review_form default'>
                <div className='form_header'>
                  <div className='title'>Write a review</div>
                </div>
                <div className='rating_selector'>
                  <span className='fas fa-star rating_option_1' onClick={() => {setRatingSelected(1)}}></span>
                  <span className='fas fa-star rating_option_2' onClick={() => {setRatingSelected(2)}}></span>
                  <span className='fas fa-star rating_option_3' onClick={() => {setRatingSelected(3)}}></span>
                  <span className='fas fa-star rating_option_4' onClick={() => {setRatingSelected(4)}}></span>
                  <span className='fas fa-star rating_option_5' onClick={() => {setRatingSelected(5)}}></span>
                </div>
                <div className='inputs'>
                  <div className='input_container'>
                    <textarea placeholder='Write your review'></textarea>
                  </div>
                </div>
                <div className='actions'>
                  <button className='submit_btn'>Submit</button>
                </div>
              </form>
            </div>
          </div>
          : <></>
        }

        <section className='featured_products'>
          <div className='title'>FEATURED PRODUCTS</div>
          <div className='featured_products_containers'>
            <OwlCarousel
              className='owl-theme'
              items={6}
              autoPlay={true}
              autoplayHoverPause={true}
              
              autoplaySpeed={1000}
              responsive={{
                1150: {items: 6},
                800: {items: 4},
                600: {items: 3},
                0: {items: 2}
              }}
              dots={true}
              margin={10}
            >
            <ProductCard 
              card={1}
              productId='1'
              thumbnail={require('../assets/images/product.png')}
              title='Product Title'
              category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
              ratings={4}
              hotDeal={true}
              realPrice='100'
              discountPrice='80'
              discount='20%'
              setShowQuickView={props.setShowQuickView}
            />
            <ProductCard 
              card={1}
              productId='1'
              thumbnail={require('../assets/images/product.png')}
              title='Product Title'
              category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
              ratings={4}
              hotDeal={true}
              realPrice='100'
              discountPrice='80'
              discount='20%'
              setShowQuickView={props.setShowQuickView}
            />
            <ProductCard 
              card={1}
              productId='1'
              thumbnail={require('../assets/images/product.png')}
              title='Product Title'
              category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
              ratings={4}
              hotDeal={true}
              realPrice='100'
              discountPrice='80'
              discount='20%'
              setShowQuickView={props.setShowQuickView}
            />
            <ProductCard 
              card={1}
              productId='1'
              thumbnail={require('../assets/images/product.png')}
              title='Product Title'
              category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
              ratings={4}
              hotDeal={true}
              realPrice='100'
              discountPrice='80'
              discount='20%'
              setShowQuickView={props.setShowQuickView}
            />
            <ProductCard 
              card={1}
              productId='1'
              thumbnail={require('../assets/images/product.png')}
              title='Product Title'
              category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
              ratings={4}
              hotDeal={true}
              realPrice='100'
              discountPrice='80'
              discount='20%'
              setShowQuickView={props.setShowQuickView}
            />
            <ProductCard 
              card={1}
              productId='1'
              thumbnail={require('../assets/images/product.png')}
              title='Product Title'
              category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
              ratings={4}
              hotDeal={true}
              realPrice='100'
              discountPrice='80'
              discount='20%'
              setShowQuickView={props.setShowQuickView}
            />
            <ProductCard 
              card={1}
              productId='1'
              thumbnail={require('../assets/images/product.png')}
              title='Product Title'
              category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
              ratings={4}
              hotDeal={true}
              realPrice='100'
              discountPrice='80'
              discount='20%'
              setShowQuickView={props.setShowQuickView}
            />
            <ProductCard 
              card={1}
              productId='1'
              thumbnail={require('../assets/images/product.png')}
              title='Product Title'
              category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
              ratings={4}
              hotDeal={true}
              realPrice='100'
              discountPrice='80'
              discount='20%'
              setShowQuickView={props.setShowQuickView}
            />
            <ProductCard 
              card={1}
              productId='1'
              thumbnail={require('../assets/images/product.png')}
              title='Product Title'
              category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
              ratings={4}
              hotDeal={true}
              realPrice='100'
              discountPrice='80'
              discount='20%'
              setShowQuickView={props.setShowQuickView}
            />
            <ProductCard 
              card={1}
              productId='1'
              thumbnail={require('../assets/images/product.png')}
              title='Product Title'
              category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
              ratings={4}
              hotDeal={true}
              realPrice='100'
              discountPrice='80'
              discount='20%'
              setShowQuickView={props.setShowQuickView}
            />
            </OwlCarousel>
          </div>
        </section>

      </div>
    </div>
  )
}
